import React, { useState, useEffect } from "react";
import "../Assets/css/index.css";
import axiosMain from "../http/axiosMain";
import { useNavigate } from "react-router-dom";
import BackVector from "../Assets/Img/BackVector.svg";

const SettingsPage = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const userRole = sessionStorage.getItem("userType");

  const handleDeleteClick = () => {
    setShowModal(true);
    document.querySelector(".navbar").classList.add("navbar-dull"); // Apply blur
};

const closeModal = () => {
    setShowModal(false);
    document.querySelector(".navbar").classList.remove("navbar-dull"); // Remove blur
};

  const handleBackNavigation = () => {
    if (userRole === "influencer") {
      navigate("/influencer-home");
    } else if (userRole === "brand") {
      navigate("/brand-home");
    } else {
      navigate("/"); // Default navigation (e.g., homepage)
    }
  };

  const confirmDelete = async () => {
    try {
      const response = await axiosMain.delete(`/api/v1/delete-user`, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        localStorage.clear();
        window.location.reload();
      }
      navigate("/signUp");
      window.location.reload();
    } catch (error) {
      console.error("Error deleting account:", error);
      alert("Failed to delete account. Please try again.");
    }
  };

  return (
    <>
      <button onClick={handleBackNavigation} className="navback-button">
        <img src={BackVector} alt="back" style={{ marginRight: "8px" }} />
        Back
      </button>

      <div className="settings-page">
        {/* General Preferences Card */}
        <div class="settings-container">
          <h3 class="settings-title">General preferences</h3>
          <div class="settings-list">
            <div class="settings-item">
              <span>Language</span>
              <span class="settings-value">
                <span class="arrow">→</span>
              </span>
            </div>
            <div class="settings-item">
              <span>Content language</span>
              <span class="settings-value">
                <span class="arrow">→</span>
              </span>
            </div>
            <div class="settings-item">
              <span>Autoplay videos</span>
              <span class="settings-value">
                <span class="text-muted">On</span>
                <span class="arrow">→</span>
              </span>
            </div>
            <div class="settings-item">
              <span>Sound effects</span>
              <span class="settings-value">
                <span class="text-muted">On</span>
                <span class="arrow">→</span>
              </span>
            </div>
            <div class="settings-item">
              <span>Showing profile photos</span>
              <span class="settings-value">
                <span class="text-muted">All Insocial members</span>
                <span class="arrow">→</span>
              </span>
            </div>
            <div class="settings-item">
              <span>Preferred Feed View</span>
              <span class="settings-value">
                <span class="text-muted">
                  Most relevant posts (Recommended)
                </span>
                <span class="arrow">→</span>
              </span>
            </div>
            <div class="settings-item">
              <span>People you unfollowed</span>
              <span class="settings-value">
                <span class="arrow">→</span>
              </span>
            </div>
          </div>
        </div>

        <div class="settings-container">
          <h3 class="settings-title">Subscriptions & payments</h3>
          <div class="settings-list">
            <div class="settings-item">
              <span>Upgrade for Free</span>
              <span class="arrow">→</span>
            </div>
            <div class="settings-item">
              <span>View purchase history</span>
              <span class="arrow">→</span>
            </div>
          </div>
        </div>

        {/* Account Management Card */}
        <div className="settings-container">
          <h3 className="settings-title">Account management</h3>
          <div className="settings-list">
            <div className="settings-item">
              <span>Hibernate account</span>
              <span className="arrow">→</span>
            </div>
            <div
              className="settings-item delete-account"
              onClick={handleDeleteClick}
            >
              <span>Delete account</span>
              <span className="arrow">→</span>
            </div>
          </div>
        </div>

        {/* Delete Account Modal */}
        {showModal && (
          <div className="modal-overlay">
            <div className="modal-content-setting">
              <h3 className="modal-title">
                Are you sure you want to delete your account?
              </h3>
              <div className="modal-buttons">
                <button className="modal-btn logout" onClick={confirmDelete}>
                  Yes
                </button>
                <button className="modal-btn cancel" onClick={closeModal}>
                  No
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SettingsPage;
